import type { AnnouncementKey } from "@sunner-cloud/api-client";
import type { NavigateOptions } from "@tanstack/react-router";
import type { ComponentProps, ComponentType } from "react";

import { AlertsLaunchDialog } from "@/components/organisms/AlertsLaunchDialog/AlertsLaunchDialog";

interface Announcement {
  Dialog: ComponentType<ComponentProps<typeof AlertsLaunchDialog>>;
  ctaNavigation: NavigateOptions;
}

export const announcementRegistry: Record<AnnouncementKey, Announcement> = {
  availability_alerts_launch: {
    Dialog: AlertsLaunchDialog,
    ctaNavigation: { to: "/alerts", search: { source: "popup" } },
  },
};
